import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const AccountDeletionPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className='policy-container'>
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Account Deletion Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="account-deletion-section">
                <h2 className="section-title">Introduction</h2>

                <div className="content-block">
                    <p>
                        At Fervoir, we respect your privacy and give you full control over your data. You can now delete your account directly through the app. This policy outlines how account deletion works in compliance with Google Play and Apple App Store requirements.
                    </p>
                </div>

                <h2 className="section-title">How to Delete Your Account</h2>
                <div className="content-block">
                    <p>
                        You can delete your Fervoir account directly in the app by navigating to:
                    </p>
                    <ul className="list">
                        <li><strong>Settings</strong> &gt; <strong>Account</strong> &gt; <strong>Delete Account</strong></li>
                    </ul>
                    <p>
                        Once you confirm your choice, we will:
                    </p>
                    <ul className="list">
                        <li>Verify your identity for security reasons.</li>
                        <li>Permanently delete your account and associated data within 7 days.</li>
                        <li>Send a confirmation email once the deletion is complete.</li>
                    </ul>
                </div>

                <h2 className="section-title">Data Removal & Retention</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>All personal data (e.g., profile information, messages, preferences) will be deleted permanently and cannot be recovered.</li>
                        <li>Some non-personal or legally required data may be retained for compliance and security reasons.</li>
                    </ul>
                </div>

                <h2 className="section-title">Important Notes</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Account deletion is irreversible—once deleted, your data cannot be restored.</li>
                        <li>If you have an active subscription, you must cancel it separately via Google Play or the App Store to avoid further charges.</li>
                    </ul>
                    <p>
                        For any privacy-related concerns, feel free to contact us at <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.
                    </p>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p>
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default AccountDeletionPolicy;